export function homeLocations() {
    $(".gallery-locations").slick({
        infinite: true,
        arrows: true,
        fade: true,
        speed: 499
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/home-locations.js